<div class="st-form">
  <app-st-impersonation-floating-banner [impersonatedEmail]="this.impersonatedEmail"
                                        [username]="this.username"
                                        [roleName]="this.consultantRoleName"
                                        (exitViewAs)="this.onExitViewAs($event)"
  >

  </app-st-impersonation-floating-banner>
</div>
<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="true"
></app-st-banner>
<br><br><br><br><br><br>
<div class="container-xxl">
  <div class="row pt-4 pb5">
    <div class="col-2 d-flex justify-content-center neg-margin">
      <!--<app-st-profile-picture></app-st-profile-picture>-->
    </div>
    <div class="col-8">
      <app-st-header-title [inputVal]="'Your Funding Goals'"></app-st-header-title>
    </div>
  </div>
  <div *ngIf="showPageErrorMessages" class="container st-form text-danger" #goUp>
    <app-st-span [inputVal]="'An error has occurred: '"></app-st-span>
    <div *ngFor="let errorMsg of pageErrorMessages" class="alert alert-danger" role="alert">
      <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
    </div>
    <br>
  </div>
  <div *ngIf="this.showPageSuccessMessages" class="container st-form text-success" #goUp>
    <div *ngFor="let successMsg of pageSuccessMessages" class="alert alert-success" role="alert">
      <b>{{successMsg.field}}:</b> {{successMsg.detail}}
    </div>
    <br>
  </div>
  <br>

  <div class="container st-form">
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button-cancel [idVal]="'top-cancel-button-id'" [label]="'Cancel'" [primary]="false"
                            (click)="this.onCancel()"></app-st-button-cancel>
      <app-st-button *ngIf="(this.username && this.impersonatedEmail == null) || (this.impersonatedEmail != null && this.consultantRoleName == 'COLLABORATIVE_ACCESS')"
        [idVal]="'top-save-button-id'" [label]="'Add Funding Goal'" [primary]="true"
                     (click)="this.onAddFundingGoal()"


      ></app-st-button>
    </div>
    <br>
    <app-st-pagination2 [idVal]="'funding-goals-pagination-id'" [collectionSize]="this.collectionSize"
                        [currentPage]="this.page" [pageSize]="15" [maxPagesDisplayed]="9"
                        [customPageSizes]="this.customPageSizes"
                        (pageChange)="changePageResults($event)" #fundinggoalspaginator
    ></app-st-pagination2>
    <br>
    <table class="table table-stripe webtext-black">
      <thead>
        <tr>
          <th scope="col">Name
            <app-st-button-sort-text-asc *ngIf="this.sortedAscFundingGoalName" [idVal]="'sort-funding-goal-name-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextFundingGoalName()">

            </app-st-button-sort-text-asc>
            <app-st-button-sort-text-desc *ngIf="!this.sortedAscFundingGoalName" [idVal]="'sort-funding-goal-name-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextFundingGoalName()">

            </app-st-button-sort-text-desc>
          </th>
          <th scope="col">Due Date
            <app-st-button-sort-number-asc *ngIf="this.sortedAscDueDate" [idVal]="'sort-due-date-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortDueDate()">

            </app-st-button-sort-number-asc>
            <app-st-button-sort-number-desc *ngIf="!this.sortedAscDueDate" [idVal]="'sort-due-date-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortDueDate()">

            </app-st-button-sort-number-desc>
          </th>
          <th scope="col">Funding Goal ($ USD)
            <app-st-button-sort-number-asc *ngIf="this.sortedAscFundingGoalAmt" [idVal]="'sort-funding-goal-amt-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortNumberFundingGoalAmt()">

            </app-st-button-sort-number-asc>
            <app-st-button-sort-number-desc *ngIf="!this.sortedAscFundingGoalAmt" [idVal]="'sort-funding-goal-amt-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortNumberFundingGoalAmt()">

            </app-st-button-sort-number-desc>
          </th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let fundingGoal of fundingGoals">
          <td>{{fundingGoal['fundingGoalName']}}</td>
          <td>{{fundingGoal['fundingDueDate']}}</td>
          <td>{{fundingGoal['formattedFundingAmtNeeded']}}</td>
          <td>
            <a *ngIf="(this.impersonatedEmail != null && this.consultantRoleName == 'READ_ONLY_ACCESS')"
               (click)="onViewFundingGoal(fundingGoal)">
              <i class="bi bi-eye"></i>
            </a>&nbsp;
            <a *ngIf="(this.username && this.impersonatedEmail == null) ||
                  (this.impersonatedEmail != null && this.consultantRoleName == 'COLLABORATIVE_ACCESS')"
               (click)="onDeleteFundingGoal(fundingGoal)">
              <i class="bi bi-trash"></i>
            </a>&nbsp;
            <a *ngIf="(this.username && this.impersonatedEmail == null) ||
                  (this.impersonatedEmail != null && this.consultantRoleName == 'COLLABORATIVE_ACCESS')"
              (click)="onEditFundingGoal(fundingGoal)">
              <i class="bi bi-pencil-fill"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <br>
    <app-st-button-back-to-top></app-st-button-back-to-top>
    <br>
  </div>
</div>

